import React, { useRef, useState, memo } from "react";
import html2canvas from "html2canvas";
import DropdownToolTip from "../Dropdown/DropdownToolTip";
import Modal from "../Modal/Modal";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { fetchAnaliseIA } from "../../controler/comunicacao";

function parseLine(line) {
  // Split by **bold** markers, then bold remaining bare numbers/percentages
  const segments = line.split(/(\*\*[^*]+\*\*)/g);
  return segments.flatMap((seg, j) => {
    if (seg.startsWith("**") && seg.endsWith("**")) {
      return [<strong key={j}>{seg.slice(2, -2)}</strong>];
    }
    // Bold bare numbers/percentages not already wrapped
    const parts = seg.split(/(\b\d+(?:[.,]\d+)*\s*%?)/g);
    return parts.map((part, k) =>
      /^\d/.test(part) ? <strong key={`${j}-${k}`}>{part}</strong> : part
    );
  });
}

function renderAnalise(text) {
  return text.split("\n").map((line, i) => {
    if (line.startsWith("### ")) {
      const content = line.replace(/^###\s*/, "");
      return (
        <div key={i} className="card-analise-section-title">
          {content}
        </div>
      );
    }
    if (line.trim() === "") return <div key={i} className="card-analise-spacer" />;
    return <p key={i} className="card-analise-paragraph">{parseLine(line)}</p>;
  });
}

function CardChart({
  title,
  tooltipText,
  modalId,
  loading,
  children,
  cols,
  chartData = null,
  bodyStyle = {},
}) {
  const chartRef = useRef(null);
  const [analise, setAnalise] = useState(null);
  const [analiseLoading, setAnaliseLoading] = useState(false);
  const [analiseVisible, setAnaliseVisible] = useState(false);

  const handleAnalise = async () => {
    if (analise !== null) {
      setAnaliseVisible((v) => !v);
      return;
    }
    setAnaliseVisible(true);
    setAnaliseLoading(true);
    const canvas = await html2canvas(chartRef.current, {
      useCORS: true,
      scale: 1.5,
    });
    const imageBase64 = canvas.toDataURL("image/png").split(",")[1];
    const resultado = await fetchAnaliseIA(imageBase64, title, chartData);
    setAnalise(resultado ?? "Não foi possível gerar a análise.");
    setAnaliseLoading(false);
  };

  return (
    <div className={cols}>
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="m-0">{title}</h5>
          <div className="d-inline-flex align-items-center">
            <button
              className="btn-ghost-ia"
              onClick={handleAnalise}
              title="Análise por IA"
            >
              🤖
            </button>
            <DropdownToolTip>
              <p className="mb-2">{tooltipText}</p>
            </DropdownToolTip>
            <Modal title={title} id={modalId}>
              {children}
            </Modal>
          </div>
        </div>
        <div className="card-body card-body-graph" ref={chartRef} style={bodyStyle}>
          {loading ? <LoadingAnimation /> : children}
        </div>
        {analiseVisible && (
          <div className="card-analise-ia">
            <div className="card-analise-header">🤖 Análise Epidemiológica</div>
            {analiseLoading ? (
              <div className="card-analise-loading">
                <div className="card-analise-progress">
                  <div className="card-analise-progress-fill" />
                </div>
                <span>Analisando imagem com IA...</span>
              </div>
            ) : (
              <div className="card-analise-text">{renderAnalise(analise)}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(CardChart);
